export type BrandIdentifiers = { uuid?: string; brandID?: string; code?: string };

export type BrandSourceName = 'query' | 'url' | 'resource' | 'store' | 'token';

// gloss
export type BrandSourceContext = {
  url: URL;
  hostname: string;
  resource?: BrandIdentifiers;
};

export type BrandSource = {
  name: BrandSourceName;
  resolve: (context: BrandSourceContext) => BrandIdentifiers | null;
};

export const namesABrand = (identifiers: BrandIdentifiers | null): identifiers is BrandIdentifiers =>
  Boolean(identifiers && (identifiers.uuid || identifiers.brandID || identifiers.code));
